function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 *  树的中序遍历
 * @param tree
 * @param fn
 * @returns
 */
export function midForEach(tree, fn, _ref) {
  var _ref$findKey = _ref.findKey,
    findKey = _ref$findKey === void 0 ? 'children' : _ref$findKey;
  if (!Array.isArray(tree)) return;
  var task = _toConsumableArray(tree);
  var deep = 0;
  function loopClearTask(d) {
    var nowLength = task.length;
    task.forEach(function (item, index) {
      fn(item, d, index);
      if (item[findKey] && Array.isArray(item[findKey])) {
        var _task;
        (_task = task).push.apply(_task, _toConsumableArray(item[findKey]));
      }
    });
    task = task.slice(nowLength);
    if (task.length) {
      loopClearTask(++deep);
    }
  }
  loopClearTask(deep);
}

/**
 *  使用中序遍历查找元素
 * @param tree
 * @param fn
 * @returns
 */
export function findItem(tree, fn, _ref2) {
  var _ref2$findKey = _ref2.findKey,
    findKey = _ref2$findKey === void 0 ? 'children' : _ref2$findKey;
  if (!Array.isArray(tree)) return;
  var task = _toConsumableArray(tree);
  var deep = 0;
  function loopClearTask(d) {
    var nowLength = task.length;
    for (var i = 0; i < nowLength; ++i) {
      var _item = task[i];
      if (fn(_item, d, i)) {
        return _item;
      }
      if (_item[findKey] && Array.isArray(_item[findKey])) {
        var _task2;
        (_task2 = task).push.apply(_task2, _toConsumableArray(_item[findKey]));
      }
    }
    task = task.slice(nowLength);
    if (task.length) {
      return loopClearTask(++deep);
    }
  }
  return loopClearTask(deep);
}